"use strict";

jQuery.noConflict();
(function($){

	$(document).bind('gform_post_render', function(){

		// Form sections
		if ($('.gfield.layout-section').length) {

			$('.gform_wrapper').each(function(){

				var $form = $(this);

				// Modify the layout, grouping the sections
				var $sections = [];

				$form.find('.gfield').each(function(){
					var $field = $(this);
					if ($field.hasClass('layout-section')) {
						$sections.push([]);
					}

					if ($sections[$sections.length-1]) {
						$sections[$sections.length-1].push($field);
					}
				});


				$.each($sections, function(i, section){
					var $wrap = $('<div id="section-wrap_' + i + '" class="section-wrap" />');
					$form.find('.gform_fields').append($wrap);
					$.each(section, function(n, $field){
						$wrap.append($field);
						var classes = $field.attr('class').split(' ');
						$.each(classes, function(n, cls){
							if (cls !== 'layout-section' && cls.indexOf('layout-') >= 0) {
								$wrap.addClass(cls);
								return false;
							}
						});
					});
				});

			});

		}

		var $redeemForm = $('#gform_4');
		if ($redeemForm.length) {

			var $couponSelect = $redeemForm.find('.gfield.coupon-posts select');
			var $dateSelect = $redeemForm.find('.gfield.coupon-dates select');
			var $couponContent = $redeemForm.find('.gfield.coupon-content .dynamic-content');

			if ($couponSelect.length && $dateSelect.length) {

				$couponSelect.change(function(){
					var val = $(this).val();
					if (val !== '') {

						$dateSelect.empty();
						$couponContent.empty();

						var cb = new Date().getTime();
						$.ajax({
							url: window.global_vars.theme_dir + '/_get-coupon-post.php?cb=' + cb,
							dataType: 'json',
							data: {
								pid: parseInt(val, 10)
							},
							cache: false,
							success: function(data, textStatus, jqXHR){

								console.log('data', data);

								if (data) {
									if (data.dates) {
										$dateSelect.append('<option value="">Select a Date</option>');
										$.each(data.dates, function(i, date){
											$dateSelect.append('<option>'+date+'</option>');
										});
										$dateSelect.trigger('change');
									}
									if (data.content && $couponContent.length) {
										$couponContent.html(htmlDecode(data.content));
									}
								}

							},
							error: function(jqXHR, textStatus, errorThrown) {
								console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
								alert('An error occured while loading the dates. Please try again.');
							}
						});

					}
				});

				/*
				if ($couponSelect.val() !== '' && $couponSelect.val() !== 'Select a Coupon') {
					$couponSelect.trigger('change');
				}
				*/

			}

		}

	});

    $(document).ready(function(){


        var $window = $(window);
        var $body = $('body');
        var $htmlBody = $('html, body');
        var $main = $('#main');
        var $footer = $('#footer');
        var $header = $('#header');

        var backgroundSize = (typeof(Modernizr) !== 'undefined') ? Modernizr.backgroundsize : false;

        var windowWidth = $window.width();
        var windowHeight = $window.width();
        var viewableHeight = 0;

        var palmBreakpoint = 570;//480;
        var lapBreakpoint = 1023;
        var ignoreResize = false;
        var isDesk;
        var isLap;
        var isPalm;
        var hasTouch = (typeof(Modernizr) !== 'undefined' && typeof(Modernizr.touch) !== undefined) ? Modernizr.touch : false;
        var isRetina = (typeof(Modernizr) !== 'undefined') ? Modernizr.highres : false;
        var retinaSizeBuffer = 40;



      /***************************
       *
       *  EXTERNAL LINKS
       *
       ***************************/

      $('a[rel="external"]').attr('target', '_blank');

        $("#mobile-menu").mmenu({
            
            position:'right'
            
         });

        $(".owl-home").owlCarousel({
 
              //navigation : true, // Show next and prev buttons
              slideSpeed : 300,
              pagination : true,
              singleItem : true,
              navigationText : false,
              autoPlay: true,
              mouseDrag: false,
         
              // "singleItem:true" is a shortcut for:
              // items : 1, 
              // itemsDesktop : false,
              // itemsDesktopSmall : false,
              // itemsTablet: false,
              // itemsMobile : false
         
          });
        


      /***************************
       *
       *  FANCYBOX
       *
       ***************************/

      function fancyBoxOpenCloseEffect() {
        return (!isPalm) ? 'elastic' : 'none';
      }

      function fancyBoxNextPrevEffect() {
        return (!isPalm) ? 'elastic' : 'none';
      }

      $('.fancybox').fancybox({
        padding: 0,
        margin: (!isPalm) ? 20 : 0,
        openEffect: fancyBoxOpenCloseEffect(),
        closeEffect: fancyBoxOpenCloseEffect(),
        nextEffect: fancyBoxNextPrevEffect(),
        prevEffect: fancyBoxNextPrevEffect(),
        caption: {
          type: 'inside'
        },
        tpl: {
          closeBtn: '<a title="Close" class="fancybox-item fancybox-close sprite sprite--close" href="javascript:;"></a>',
          next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span class="sprite sprite--next"></span></a>',
          prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span class="sprite sprite--prev"></span></a>'
        }
      });


      // Small form window
      $('.fancybox-form-window').fancybox({
        wrapCSS: 'form-window',
        padding: 0,
        openEffect: 'fade',
        closeEffect: 'fade',
        minWidth: ($window.width() < 400) ? $window.width() : 400,
        maxWidth: ($window.width() < 400) ? $window.width() : 400,
        maxHeight: ($window.height() < 480) ? 9999 : 480,
        margin: (isPalm) ? 0 : 20,
        autoSize: isPalm,
        autoResize: true,
        tpl: {
          closeBtn: '<a title="Close" class="fancybox-item fancybox-close sprite sprite--close" href="javascript:;"></a>'
        }
      });


        /***************************
         *
         *	VOUCHERS ADMIN TABLE
         *
         ***************************/
        var $vouchersTable = $('#vouchers_table');
        if ($vouchersTable.length) {
            $vouchersTable.DataTable({
                searching: true,
                //scrollX: true,
                orderMulti: true,
                paging: true,
                pageLength: 100,
                ordering: true,
                autoWidth: true,
                lengthChange: true,
                processing: false
            });
        }

	    var $vouchersForm = $('#vouchers_admin_form');
	    var $vouchersFormSubmit;
	    var $vouchersFormBulkActionSelect;

	    if ($vouchersForm.length) {
		    $vouchersFormSubmit = $vouchersForm.find('button[type="submit"]');
		    $vouchersFormBulkActionSelect = $vouchersForm.find('#bulk_action_select');
		    $vouchersFormSubmit.click(function(){
			    if ($vouchersForm.find('input:checkbox:checked').length === 0 || $vouchersFormBulkActionSelect.val() === '') {
				    return false;
			    }
			    else if ($vouchersFormBulkActionSelect.val() === 'delete') {
				    return confirm('Are you sure you want to delete the selected item(s)?');
			    }
		    });
	    }

	    $body.on('click', '#vouchers_admin_form .delete-btn', function(){
		    return confirm('Are you sure you want to delete this item?');
	    });

      /***************************
         *
         *  RESPONSIVE IMAGES
         *  Based on the image having data-2x (and other) data attributes and the 'responsive' class
       *  Eg <img src="path/to/standard/image" class="responsive" data-width="width_of_standard_image" data-height="height_of_standard_image" data-2x="path/to/2x/image" data-2x_width="width_of_2x_image" data-2x_height="height_of_2x_image" />
         *
         ***************************/

        var $responsiveImage;
        var retinaSrc;
        var retinaSrcWidth;
        var retinaSrcHeight;
        var standardSrcWidth;
        var standardSrcHeight;
        var responsiveImageWidth;
        var responsiveImageHeight;
        var retinaSrcRequired;

        $('img.responsive').each(function(){
            $responsiveImage = $(this);
            retinaSrc = $responsiveImage.data('2x');
            retinaSrcWidth = $responsiveImage.data('2x_width');
            retinaSrcHeight = $responsiveImage.data('2x_height');
            standardSrcWidth = $responsiveImage.data('width');
            standardSrcHeight = $responsiveImage.data('height');
            responsiveImageWidth = $responsiveImage.width();
            responsiveImageHeight = $responsiveImage.height();

            // retina src may not even be required, depending on the current size of the image wrapper element
            // the standard image may not be at 100%
            // we've got a buffer of 40px in determining if we even need to use retina src to still get "retina" display
            retinaSrcRequired = ((responsiveImageWidth * 2) > (standardSrcWidth + retinaSizeBuffer));

            if (retinaSrc && isRetina && retinaSrcRequired) {
                $responsiveImage.attr('src', retinaSrc);
            }
        });


      /***************************
         *
         *  FOOTER
         *
         ***************************/
      var $page = $('.page-wrapper');
      function responsiveFooter() {

          if ($page.outerHeight() < windowHeight) {
              $footer.addClass('sticky');
          }
          else {
              $footer.removeClass('sticky');
          }

      }


      /***************************
         *
         *  RESPONSIVE / BREAKPOINTS
         *
         ***************************/

        function resizeTasks() {
            // Check breakpoints
            windowWidth = $window.width();
            windowHeight = $window.height();
            viewableHeight = windowHeight - ( $footer.height() + $header.height() );
            isPalm = (windowWidth <= palmBreakpoint);
            isLap = (windowWidth > palmBreakpoint && windowWidth <= lapBreakpoint);
            isDesk = (windowWidth > lapBreakpoint);

            if (!ignoreResize) {
              // if you have any functions that need to be (re)run on every window resize, call them here
                responsiveFooter();
            }
        }

        $window.on('resize', debounce(resizeTasks, 100));
        $window.trigger('resize');

      $window.on('load', resizeTasks);

    });


})(jQuery);
